import React, { useEffect } from 'react';
// eslint-disable-next-line jira/restricted/styled-components, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { ThemeProvider } from 'styled-components';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import { ServiceDeskAnalyticsContext } from '@atlassian/jira-servicedesk-analytics/src/ui/servicedesk-analytics-context/index.tsx';
import { useGettingStartedPanelState } from '@atlassian/jira-servicedesk-getting-started-panel-state/src/main.tsx';
import { JsdGettingStartedPanelShouldRender } from '@atlassian/jira-servicedesk-getting-started-panel/src/async';
import { ProjectSubProductUpdater } from '@atlassian/jira-spa-apps-common/src/analytics-sub-product/project-sub-product-updater/index.tsx';
import { ProjectSettingsController } from '@atlassian/jira-spa-apps-project-settings-common/src/components/routing-filter';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { useRouter } from '@atlassian/react-resource-router';
import ServiceDeskChatSettings from './chat-settings';
import { METRICS_PAGE_ID } from './chat-settings/common/constants';
import useProjectContext from './chat-settings/controllers/project-context';

export const ServiceDeskChatSettingsPage = () => {
	const tenantContext = useTenantContext();
	const { data } = useProjectContext();
	const projectContext = data;
	const [{ match }] = useRouter();
	const { projectKey } = match.params;

	const [{ data: gspData }, { resolveTask }] = useGettingStartedPanelState();

	useEffect(() => {
		if (gspData) {
			resolveTask('servicedesk-chat-requests-setup').catch();
		}
	}, [gspData, resolveTask]);

	return (
		<ProjectSettingsController projectKey={projectKey}>
			<JSErrorBoundary
				id={METRICS_PAGE_ID}
				packageName="jiraSpaAppsProjectSettingsServiceDeskChatSettings"
				teamName="itops-mithril"
				fallback="flag"
			>
				<ProjectSubProductUpdater />
				<ThemeProvider theme={{}}>
					<ServiceDeskAnalyticsContext>
						<ServiceDeskChatSettings
							tenantContext={tenantContext}
							projectContext={projectContext}
						/>
					</ServiceDeskAnalyticsContext>
				</ThemeProvider>
			</JSErrorBoundary>
			<JsdGettingStartedPanelShouldRender />
		</ProjectSettingsController>
	);
};
export default ServiceDeskChatSettingsPage;
